<a id="app-component-top"></a>

<router-outlet>
	<fieldset bsMigration [bs3Class]="['panel-default']" *ngIf="Loading$ | async" class="panel">
		<legend bsMigration class="panel-heading">Loading..</legend>
		<div bsMigration class="panel-body">
			<p><em>Loading membership wizard...</em></p>
			<div class="progress">
				<div class="progress-bar progress-bar-striped active" role="progressbar" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
			</div>
		</div>
	</fieldset>
</router-outlet>

<hr class="visible-xs">
